/**
 * Referencias a catálogos de Talana guardadas en la ficha del colaborador
 * (PLAN_INTEGRACION_TALANA §4.2, decisión 2026-09-22): los campos AFP, salud,
 * banco, tipo de contrato, jornada, nacionalidad, comuna, ciudad y sucursal
 * dejan de ser texto y guardan `{ uid, talanaId, name, code }` del espejo
 * `erpTalana*`. Las fichas anteriores traen strings: estos helpers aceptan
 * ambos para que nada se rompa mientras se corrigen ficha a ficha.
 *
 * Espejo backend: server/src/services/erpTalanaRefs.js (mantener en sincronía).
 */

export const isTalanaRef = (value) =>
  Boolean(value) && typeof value === 'object' && value.talanaId !== undefined && value.talanaId !== null;

/** Nombre a mostrar, venga como referencia o como texto legado */
export const refName = (value) => {
  if (!value) return '';
  if (typeof value === 'string') return value;
  return value.name || value.code || String(value.talanaId ?? '');
};

/** Referencia mínima que se guarda en la ficha a partir de un item del catálogo */
export const toTalanaRef = (item, extra = {}) => {
  if (!item) return '';
  return {
    uid: item.uid,
    talanaId: item.talanaId,
    name: item.name || null,
    code: item.code || null,
    ...extra,
  };
};

/** Normaliza texto para cruzar valores legados con el catálogo */
export const normalizeName = (value) =>
  String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ');

/**
 * Tipo de contrato interno de Amanda a partir del nombre Talana. Talana tiene
 * 7 tipos; Amanda sigue razonando con 3 (causal EST, export). Los que no
 * calzan (honorarios, casa particular, técnico audiovisual) quedan en null.
 */
export const contractKindFromName = (name) => {
  const n = normalizeName(name);
  if (!n) return null;
  if (n.includes('indefinido')) return 'indefinite';
  if (n.includes('obra') || n.includes('faena')) return 'work_or_task';
  if (n.includes('plazo fijo')) return 'fixed_term';
  return null;
};

/** 'fonasa' | 'isapre' | 'none' según el tipo del item de /prevision/ */
export const healthSystemFromItem = (item) => {
  const tipo = normalizeName(item?.extra?.tipo);
  if (tipo === 'fonasa') return 'fonasa';
  if (tipo.startsWith('sin')) return 'none';
  return 'isapre';
};
